import { getBrowserFingerprint } from '@patsnap-utils/browser-fingerprint'
import { InitCookie } from '@patsnap/init-cookie'
import { getSingle } from '@patsnap/synapse_common_utils'
import type { Ref } from '@vue/composition-api'
import { readonly, shallowRef } from '@vue/composition-api'

export type UseBrowserFingerprintReturn = {
  fingerprint: Readonly<Ref<string>>
  getFingerprint: () => Promise<string>
}

/**
 * 获取浏览器指纹 composable（全局单例）
 */
export const useBrowserFingerprint: () => UseBrowserFingerprintReturn = getSingle(() => {
  const fingerprint = shallowRef('')

  const getFingerprint = async (): Promise<string> => {
    if (typeof window === 'undefined') {
      return ''
    }

    if (fingerprint.value) {
      return fingerprint.value
    }

    try {
      fingerprint.value = InitCookie.getVisitorId() || (await getBrowserFingerprint())
      return fingerprint.value
    } catch (error) {
      return ''
    }
  }

  return {
    fingerprint: readonly(fingerprint),
    getFingerprint,
  }
})
